<template>
  <div class="nav_big_container">
    <div class="login_nav">
      <div class="sm_box">
        <div class="left">
          <p>
            <span>{{$t("header.welcome")}}</span>
            <a :href="url" class="paijie_test">{{ text }}</a>
            <a href="javascript:void(0);" style="margin-left: 20px;" @click="langToggle">{{ language }}</a>
          </p>
        </div>
        <div class="right" :class="{ no_login : !hasToken }">
          <!-- <a href="#">机构中心</a>| -->
          <router-link to="/login" v-if="hasToken == false">{{$t("header.login")}}</router-link>
          <router-link to="/person" v-if="hasToken == true">{{$t("header.me")}} | </router-link>
          <router-link to="/" v-if="hasToken == true">
            <span @click="localClear">{{$t("header.log_out")}}</span>
          </router-link>|
          <p>{{$t("header.customer_service")}}：<span class="c_red">400-9005-905</span></p>
        </div>
      </div>
    </div>
    <div class="nav_container">
      <div class="logo_container">
        <router-link to="/">
          <img src="@/assets/images/logo.png">
        </router-link>
        <div class="mobile" :class="{ no_login : !hasToken }">
          <!-- <a
            href="javascript:void(0);"
            style="margin-left: 20px;"
            @click="langToggle"
          >{{ language }}</a> -->
          <router-link to="/login" v-if="hasToken == false">{{$t("header.login")}}</router-link>
          <router-link to="/person" v-if="hasToken == true">{{$t("header.me")}}</router-link>
          <span v-if="hasToken == true"> | </span>
          <router-link to="/" v-if="hasToken == true">
            <span @click="localClear">{{$t("header.log_out")}}</span>
          </router-link>
        </div>
      </div>
      <div class="search_mobile">
        <div class="left">
          <input type="text" name="search" :placeholder='$t("header.search")' @keyup.13="searchBtn" v-model="searchVal">
        </div>
        <div class="right" @click="searchBtn">
          <img src="@/assets/images/search.png">
        </div>
      </div>
      <div class="search">
        <div class="left">
          <input type="text" name="search" :placeholder='$t("header.search")' @keyup.13="searchBtn" v-model="searchVal">
        </div>
        <div class="right" @click="searchBtn">
          <img src="@/assets/images/sso.gif">
        </div>
      </div>

    </div>
    <div class="nav_new_mobile">
      <div class="nav">
        <router-link to="/">{{$t("header.nav.home")}}</router-link>
        <router-link to="/biaodi?type=全部">{{$t("header.nav.subject")}}</router-link>
        <router-link to="/subjects">{{$t("footer.keep_on_record.nav.notice")}}</router-link>
        <router-link to="/biaodi?type=%E5%85%A8%E9%83%A8&page=1&status=3">成交案例</router-link>
        <router-link to="/synopsis">{{$t("header.nav.about_us")}}</router-link>
        <router-link to="/pai">拍品送拍</router-link>
        <!-- <router-link to="/note">{{$t("header.nav.note")}}</router-link> -->
      </div>
    </div>
    <div class="nav_new">
      <div class="nav">
        <router-link to="/">{{$t("header.nav.home")}}</router-link>
        <!-- <router-link to="/biaodi?type=全部">{{$t("header.nav.subject")}}</router-link> -->
        <div class="dropdown">
          <button class="dropbtn">
            <router-link style="line-height:70px;margin-bottom:-30px" :to="{ path:'/biaodi',query:{ type:'全部',page:1 }}">{{$t("header.nav.subject")}}</router-link>
          </button>
          <!-- <div
            class="dropdown-content"
            style="width: 600px;"
          >
            <router-link :to="{ path:'/biaodi',query:{ type:'二手设备',page:1 }}">二手设备</router-link>
            <router-link :to="{ path:'/biaodi',query:{ type:'废旧金属',page:1 }}">废旧金属</router-link>
            <router-link :to="{ path:'/biaodi',query:{ type:'货存积压',page:1 }}">货存积压</router-link>
            <router-link :to="{ path:'/biaodi',query:{ type:'机动车',page:1 }}">机动车</router-link>
            <router-link :to="{ path:'/biaodi',query:{ type:'土地',page:1 }}">土地</router-link>
            <router-link :to="{ path:'/biaodi',query:{ type:'房产',page:1 }}">房产</router-link>
          </div> -->
        </div>
        <!-- <router-link to="/meetings">拍卖会</router-link> -->

        <router-link to="/subjects">{{$t("footer.keep_on_record.nav.notice")}}</router-link>
        <!-- <router-link to="/biaodi?type=%E5%85%A8%E9%83%A8&page=1&status=3">成交案例</router-link> -->
        <!-- <router-link to="/paimaigonggao">{{$t("header.nav.notice")}}</router-link> -->

        <!-- <router-link to="/paimaiqiye">{{$t("header.nav.enterprise")}}</router-link> -->
        <!-- <router-link to="/aboutwe">{{$t("header.nav.about_us")}}</router-link> -->
        <div class="dropdown">
          <button class="dropbtn">
            <router-link to="/synopsis" style="line-height:70px;margin-bottom:-30px">{{$t("header.nav.about_us")}}</router-link>
          </button>

          <div class="dropdown-content" style="left: -380px;width: 800px;">
            <a href="/synopsis">拍界简介</a>
            <a href="/culture">企业文化</a>
            <a href="/service">服务内容</a>
            <a href="/honor">企业荣誉</a>
            <a href="/development">发展历程</a>
            <a href="/contact">联系我们</a>
            <a href="/partner">招募合伙人</a>
            <a href="/paimaigonggao">拍卖资讯</a>
            <!-- <router-link to="/paimaigonggao">{{$t("header.nav.notice")}}</router-link> -->
            <!-- <a href="/company">联系我们</a> -->
          </div>
        </div>
        <router-link to="/note">{{$t("header.nav.note")}}</router-link>
        <router-link to="/pai">拍品送拍</router-link>
        <router-link to="/person?act=jp">我的竞拍</router-link>
        <!-- <router-link to="/company">联系我们</router-link> -->

      </div>
    </div>
  </div>
</template>

<style>
.dropbtn {
  background-color: #4b4b4b;
  color: white;
  /* width: 150px; */
  /*padding: 16px;*/
  font-size: 16px;
  border: none;
  cursor: pointer;
}
.dropbtn a {
  margin-bottom: -7px;
}
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background: rgba(255, 255, 255, 0.7);
  /*min-width: 100px;*/
  box-shadow: 0px 8px 16px 0px rgba(5, 3, 3, 0.2);
  z-index: 10;
  /* width: 600px; */
  /* left: -380px; */
}

.nav .dropdown .dropdown-content a {
  /*    color: white;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    border-radius: 0px;*/

  white-space: nowrap;
  font-size: 16px;
  color: #000;
  /* display: inline; */
  padding: 0;
  border-radius: 0px;
  line-height: 50px;
  width: 100px;
  float: left;
}

.nav .dropdown .dropdown-content a:hover {
  background-color: #808080;
  color: #ffffff;
}

.nav .dropdown .dropdown-content a.router-link-exact-active {
  background-color: #ffffff;
  /*color: white;*/
}

.dropdown:hover .dropdown-content {
  display: block;
}

/*.dropdown:hover .dropbtn {
    background-color: #f1f1f1;
	border-radius: 200px;
}*/
@media screen and (max-width: 540px) {
  .dropdown:hover .dropdown-content {
    display: none;
  }
}
</style>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  },
  inject: ['reload'],
  data () {
    return {
      language: '英文版',
      searchVal: '',
      // subjectsArr: {},
      token: localStorage.getItem('apiToken'),
      hasToken: false
    }
  },
  created () {
    this.checkToken();
    if (this.$i18n.locale == 'zh_CN') {
      this.language = '英文版';
    } else {
      this.language = 'CHINESE';
    }
  },
  mounted () {

  },
  computed: {
    url () {
      if (document.domain == "paijie.com") {
        return "http://test.paijie.com";
      } else {
        return "https://paijie.com";
      }
    },
    text () {
      if (document.domain == "paijie.com") {
        return this.$t("header.test.beta");
      } else {
        return this.$t("header.test.final");
      }
    },
  },
  methods: {
    // 搜索
    searchBtn: function () {
      this.$router.push({
        path: '/biaodi',
        query: {
          searchVal: this.searchVal,
          type: "全部",
          page: 1
        }
      })
      // this.reload();
    },
    // 检查用户local
    checkToken: function () {
      if (this.token != null) {
        // 跳转到个人中心
        this.hasToken = true
      } else {
        this.hasToken = false
      }
    },
    // 清除登录local
    localClear: function () {
      let storage = window.localStorage;
      storage.clear();
      this.reload();
      this.hasToken = false
    },
    // 多语言切换
    langToggle: function () {
      if (this.$i18n.locale == 'zh_CN') {
        this.$i18n.locale = 'en_US';
        this.language = 'CHINESE';
      } else {
        this.$i18n.locale = 'zh_CN';
        this.language = '英文版';
      }
      this.reload();
    }
  }
}
</script>